import { DateRange } from 'react-day-picker';
import { ProgramLogDto } from 'src/dtos/programLog/programLogDto';

export interface SYS5020_R01Dto extends ProgramLogDto {
 /** 사용구분명 - sys_code(ACTIONTYPE) 조인 */
 actionTypeNm: string;

    inserted: false,
    isModified: false,
    originalData: undefined,
}

export interface SYS5020_R01Filter {
    dateRange: DateRange | undefined;
    userId: string;
    userNm: string;
    programId: string;
    programNm: string;
    actionType: string;
}

export const defaultSYS5020_R01Dto: SYS5020_R01Dto = {
    userId: '',
    userNm: '',
    programId: '',
    programNm: '',
    logDt: '',
    actionType: '',
    actionTypeNm: '',
    deviceType: '',
    ipAddr: '',
    remark: '',
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    
    inserted: false,
    isModified: false,
    originalData: undefined,
};

export const defaultSYS5020_R01Filter: SYS5020_R01Filter = {
    dateRange: {
        from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        to: new Date(),
    },
    userId: '',
    userNm: '',
    programId: '',
    programNm: '',
    actionType: '',
};
